import React from 'react'
import { useGetFabricMasterQuery } from '../../../redux/ErpServices/FabricMasterServices';
import { useGetColorMasterQuery } from '../../../redux/ErpServices/ColorMasterServices';
import { useGetUnitOfMeasurementMasterQuery } from '../../../redux/ErpServices/UnitOfMeasurementServices';
import { useGetGaugeQuery } from '../../../redux/ErpServices/GaugeMasterServices';
import { useGetdesignQuery } from '../../../redux/ErpServices/DesignMasterServices';
import { useGetgsmQuery } from '../../../redux/ErpServices/GsmMasterServices';
import { useGetDiaQuery } from '../../../redux/ErpServices/DiaMasterServices';
import { useGetLoopLengthQuery } from '../../../redux/ErpServices/LoopLengthMasterServices';
import { Loader } from '../../../Basic/components';
import { findFromList } from '../../../Utils/helper';
import secureLocalStorage from 'react-secure-storage';



const params = {
  companyId: secureLocalStorage.getItem(
    sessionStorage.getItem("sessionId") + "userCompanyId"
  ),
};
const FabricProgram = ({ fabricTotal, programDetails }) => {
  const { data: fabricList } =
    useGetFabricMasterQuery({ params });

  const { data: colorList, isLoading: isColorLoading, isFetching: isColorFetching } =
    useGetColorMasterQuery({ params });

  const { data: uomList } =
    useGetUnitOfMeasurementMasterQuery({ params });

  const { data: gaugeList } =
    useGetGaugeQuery({ params });

  const { data: designList } =
    useGetdesignQuery({ params });

  const { data: gsmList } =
    useGetgsmQuery({ params });

  const { data: loopLengthList } =
    useGetLoopLengthQuery({ params });

  const { data: diaList } =
    useGetDiaQuery({ params });
  if (!fabricList || !colorList || !uomList || !gaugeList || !designList || !gsmList || !loopLengthList || !diaList) return <Loader />
  return (
    <div className='text-[10px]'>
      <div className='w-full font-bold mt-3'>
        <h1>
          PROGRAM
        </h1>
      </div>
      <table className="  border border-gray-500 w-full">
        <thead className=' border border-gray-500 top-0'>
          <tr className=''>
            <th className="table-data text-center w-16 text-[12px]">S.no</th>
            <th className="table-data text-center text-[12px]">FABRIC</th>
            <th className="table-data text-[12px]">DESIGN</th>
            <th className="table-data text-[12px] ">GSM</th>
            <th className="table-data  text-[12px]">GAUGE</th>
            <th className="table-data text-[12px] "> LL</th>
            <th className="table-data text-[12px] ">KDIA</th>
            <th className="table-data text-[12px] w-16">FDIA</th>
            <th className="table-data text-[12px] w-16">UOM</th>
            <th className="table-data text-[12px] w-16">QTY</th>
          </tr>
        </thead>
        <tbody>
          {programDetails.map((value, index) => (
            <tr className='border border-gray-500' key={index}>
              <td className='table-data text-center px-1 text-[12px] '>{index + 1} </td>
              <td className='table-data  px-1 text-[12px] '>{value.Fabric?.aliasName} </td>
              <td className='table-data  px-1 text-[12px] '>{value.Design?.name} </td>
              <td className='table-data text-right px-1 text-[12px] '>{value.Gsm?.name} </td>
              <td className='table-data text-right px-1 text-[12px] '>{value.Gauge?.name} </td>
              <td className='table-data text-right px-1 text-[12px] '>{value.LoopLength?.name} </td>
              <td className='table-data text-right px-1 text-[12px] '>{value.KDia?.name}</td>
              <td className='table-data text-right px-1 text-[12px] '> {value.FDia?.name}</td>
              <td className='table-data text-right px-1 text-[12px] '>{value.Uom?.name} </td>
              <td className='table-data text-right px-1 text-[12px] '> {value.qty}</td>
            </tr>
          ))}
          <tr>
            <td className='table-data text-center  px-1 ' colSpan={9}>TOTAL</td>
            <td className=' px-1  text-right'>{programDetails.reduce((a, c) => a + parseFloat(c.qty), 0).toFixed(3)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default FabricProgram